import React from 'react';

const FloatingLabelInput = ({ id, label, backcolor, value, readOnly = false, onChange, error }) => (
  <div className="floating-label-group">
    <input
      type="text"
      className="form-control"
      readOnly={readOnly}
      value={value || ""}
      id={id}
      autoComplete="off"
      onChange={onChange}
      aria-invalid={!!error}
    />
    <span
      className={`floating-label-${backcolor}${value ? ' floated' : ''}`}
      style={error ? { color: 'red' } : {}}
    >
      {error ? error : label}
    </span>
  </div>
);

export default FloatingLabelInput;
